import React from "react";

const PageBackground = () => (
  <>
    <div className="orb orb-violet" aria-hidden="true" />
    <div className="orb orb-cyan" aria-hidden="true" />
  </>
);

export default PageBackground;
